import { Paper, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { UserRegistration } from "@my-helpers/common";
import { ElementType, ChangeEvent } from "react";

interface UserProfileProps {
    sessionUser?: UserRegistration;
    handleChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const UserProfile: ElementType<UserProfileProps> = ({ sessionUser, handleChange }) => {
    return (
        <Paper elevation={3} sx={{ p: 4, maxWidth: 1200, margin: 'auto' }}>
            <Stack spacing={2}>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    User Profile
                </Typography>
                <TextField
                    fullWidth
                    label="First Name"
                    name="firstName"
                    value={sessionUser?.givenName}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    label="Last Name"
                    name="lastName"
                    value={sessionUser?.familyName}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={sessionUser?.email}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    label="Role"
                    name="role"
                    type="role"
                    value={sessionUser?.role}
                    onChange={handleChange}
                />
            </Stack>
        </Paper>
    );
};

export default UserProfile;